import { render, staticRenderFns } from "./regin.vue?vue&type=template&id=52764b76&scoped=true&"
import script from "./regin.vue?vue&type=script&lang=js&"
export * from "./regin.vue?vue&type=script&lang=js&"
import style0 from "./regin.vue?vue&type=style&index=0&id=52764b76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52764b76",
  null
  
)

export default component.exports